import { render } from "./ThematiqueList.vue?vue&type=template&id=0127b27e&scoped=true"
import script from "./ThematiqueList.vue?vue&type=script&lang=js"
export * from "./ThematiqueList.vue?vue&type=script&lang=js"

import "./ThematiqueList.vue?vue&type=style&index=0&id=0127b27e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0127b27e"]])

export default __exports__